import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.sass']
})
export class ConfirmDialogComponent {

  public title: string;
  public message: string;
  public confirmAction: string;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) { }

}
